/**
 * Tab Manager App Component
 *
 * Main application component with routing for Tab Manager admin interface.
 *
 * @since 1.0.0
 */

import { AdminLayout } from '@redfoxwp/core-components/components/admin-layout';
import { Redirect, Route, Switch } from 'wouter';

import { GlobalTabs } from '../global-tabs';
import { Navigation } from '../navigation';
import { SidebarFooter } from '../sidebar-footer';
import { TabList } from '../tab-list';
import type { TabManagerAppProps } from './types';

/**
 * Tab Manager App component
 *
 * @since 1.0.0
 *
 * @param props Component props.
 *
 * @return JSX element.
 */
export const TabManagerApp = (_props: TabManagerAppProps): JSX.Element => {
  return (
    <AdminLayout
      navigation={<Navigation />}
      sidebarFooter={<SidebarFooter />}
      appName={window?.redfoxTabManagerSettings?.pluginName}
      appVersion={window?.redfoxTabManagerSettings?.pluginVersion}
    >
      <Switch>
        <Route path='/'>
          <Redirect to='/tabs' />
        </Route>
        <Route path='/tabs'>
          <TabList />
        </Route>
        <Route path='/global-tabs'>
          <GlobalTabs />
        </Route>
      </Switch>
    </AdminLayout>
  );
};
